module.exports = __webpack_public_path__ + "static/media/3.5 KC Tribunj 5-14.08.2025.13768d16.JPG";